import ElseContactContact from 'components/contacts/ElseContactContact';
import React from 'react';

function ElseContactPage() {
  return (
    <div className="leftContent">
      <ElseContactContact />
    </div>
  );
}

export default ElseContactPage;
